import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useFormField } from '../FormField/FormField';

const SIZES = {
  sm: 'h-8  text-sm   px-2.5',
  md: 'h-10 text-sm   px-3',
  lg: 'h-11 text-base px-3.5',
};

export const Input = forwardRef(function Input(
  { size = 'md', leftIcon, rightIcon, leftAddon, rightAddon, isInvalid, isDisabled, className, type = 'text', id: idProp, ...rest },
  ref
) {
  const field = useFormField();
  const id = idProp || field?.id;
  const invalid = isInvalid || field?.invalid;

  const inputCls = cn(
    'w-full bg-surface text-text placeholder:text-mute-2 outline-none',
    'border border-border rounded-md transition-colors duration-fast',
    'focus:bg-surface focus:border-ink focus:ring-2 focus:ring-ink/15',
    'disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-bg-2',
    SIZES[size],
    invalid && 'border-danger focus:border-danger focus:ring-danger/20',
    leftIcon && '!pl-9',
    rightIcon && '!pr-9',
    className,
  );

  const inputEl = (
    <input
      ref={ref}
      id={id}
      type={type}
      disabled={isDisabled}
      aria-invalid={invalid || undefined}
      aria-describedby={field?.describedBy}
      className={inputCls}
      {...rest}
    />
  );

  if (leftIcon || rightIcon || leftAddon || rightAddon) {
    return (
      <div className="relative flex items-stretch w-full">
        {leftAddon && <span className="inline-flex items-center px-3 bg-bg-2 border border-r-0 border-border rounded-l-md text-sm text-mute">{leftAddon}</span>}
        <div className={cn('relative flex-1', (leftAddon || rightAddon) && '[&_input]:rounded-l-none [&_input]:rounded-r-none')}>
          {leftIcon && <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-mute pointer-events-none [&_svg]:w-4 [&_svg]:h-4">{leftIcon}</span>}
          {React.cloneElement(inputEl, {
            className: cn(inputCls, leftAddon && '!rounded-l-none', rightAddon && '!rounded-r-none'),
          })}
          {rightIcon && <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-mute pointer-events-none [&_svg]:w-4 [&_svg]:h-4">{rightIcon}</span>}
        </div>
        {rightAddon && <span className="inline-flex items-center px-3 bg-bg-2 border border-l-0 border-border rounded-r-md text-sm text-mute">{rightAddon}</span>}
      </div>
    );
  }

  return inputEl;
});

export default Input;
